import {
  CategoriaListFormService,
  EspecialListFormService,
  FraccioListFormService,
  InformacioSecundariaListFormService,
  PuntRecollidaListFormService,
  ResiduListFormService,
  SinonimListFormService,
  TipusServeiListFormService,
} from "@api/form-service";
import { FuseNavigationItem } from "@fuse/components/navigation";
import { SecondaryInfoListService } from "@modules/secondary-info/secondary-info-list/secondary-info-list.service";
import { ServiceTypesListService } from "@modules/service-types/service-types-list/service-types-list.service";
import { SpecialListService } from "@modules/special/special-list/special-list.service";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "residus",
    title: "Residus",
    type: "basic",
    icon: "recycle",
    link: "/residus",
    meta: {
      requiredServices: ResiduListFormService,
    },
  },
  {
    id: "categoria",
    title: "Categorias",
    type: "basic",
    icon: "tags",
    link: "/categoria",
    meta: {
      requiredServices: CategoriaListFormService,
    },
  },
  {
    id: "fraccio",
    title: "Fraccions",
    type: "basic",
    icon: "layer-group",
    link: "/fraccions",
    meta: {
      requiredServices: FraccioListFormService,
    },
  },
  {
    id: "punt-recollida",
    title: "Punt de recollida",
    type: "basic",
    icon: "location-dot",
    link: "/punt-recollida",
    meta: {
      requiredServices: PuntRecollidaListFormService,
    },
  },
  {
    id: "horaris",
    title: "Horaris CityOS",
    type: "basic",
    icon: "clock",
    link: "/horaris",
    meta: {
      requiredServices: FraccioListFormService,
    },
  },
  {
    id: "informacio-secundaria",
    title: "Informació Secundaria",
    type: "basic",
    icon: "circle-info",
    link: "/informacio-secundaria",
    meta: {
      requiredServices: InformacioSecundariaListFormService,
    },
  },
  {
    id: "tipus-servei",
    title: "Tipus de servei",
    type: "basic",
    icon: "clipboard-list",
    link: "/tipus-servei",
    meta: {
      requiredServices: TipusServeiListFormService,
    },
  },
  {
    id: "especial",
    title: "Especial",
    type: "basic",
    icon: "star",
    link: "/especial",
    meta: {
      requiredServices: EspecialListFormService,
    },
  },
  {
    id: "sinonims",
    title: "Sinònims",
    type: "basic",
    icon: "font",
    link: "/sinonims",
    meta: {
      requiredServices: SinonimListFormService,
    },
  },
];